/*============================================================================
  - SPOTIRE: base template
  - Include javascript for base theme and it will effect on all spaces
==============================================================================*/
$(document).on('ready', function (){
    $(".auto-click.js").click(function(){
        $(".search-bar.small--hide").addClass("intro");
    });
    $('.img_product_home').matchHeight({
        property: 'min-height',
    });
    $('.box-product-grid .product-grit').matchHeight({
        property: 'min-height',
    });
    $('.fieldFullWidth').each(function () {
        var t = $(this);
        var fullwidth = $('main').width(),
            margin_full = fullwidth / 2;
        t.css({'left': '50%', 'position': 'relative', 'width': fullwidth, 'margin-left': -margin_full});
    });
});
